exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cookies[data-v-50580270]{position:fixed;bottom:0;left:0;right:0;color:#fff;background:#fff;z-index:1000}.cookies div[data-v-50580270]{padding:1em;background:rgba(48,87,176,.9)}.cookies div span[data-v-50580270]{margin-left:1em}.cookies div span a[data-v-50580270]{color:#fff;text-decoration:underline}.cookies div button[data-v-50580270]{position:absolute;right:1em;background:#fe7154;padding-left:1.5em;padding-right:1.5em;border:none;outline:none;border-radius:5em}", ""]);

// exports
